import { c as _c } from "react/compiler-runtime";
import { useMachine } from '@xstate/react';
import constate from 'constate';
import handoffMachine from '../../utils/state-machine';
const useLocalHandoffMachine = () => {
  const $ = _c(4);
  const [state, send, service] = useMachine(handoffMachine);
  let t0;
  if ($[0] !== send || $[1] !== service || $[2] !== state) {
    t0 = [state, send, service];
    $[0] = send;
    $[1] = service;
    $[2] = state;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0 as const;
};
export const [HandoffMachineProvider, useHandoffMachine] = constate(useLocalHandoffMachine);
export default HandoffMachineProvider;